window.QuizEmbedConfig = {
  "brand": {
    "name": "Atelier des Greffières",
    "tagline": "Trouvez la céramique faite pour vous — en quelques questions.",
    "color": "#8a6d4f",
    "accent": "#b5654f",
    "productBaseUrl": "https://www.atelierdesgreffieres.com/products/",
    "shopifyImages": true
  },
  "catalogSource": {
    "type": "shopify",
    "collection": "all",
    "onlyAvailable": true,
    "excludeTag": "no-quiz",
    "tagPrefixes": {
      "forme": "forme:",
      "type": "type:",
      "taille": "taille:",
      "repas": "repas:",
      "perso": "perso:"
    }
  },
  "activeVariant": "inspiration",
  "variants": {
    "inspiration": {
      "ui": {
        "maxAlts": 2,
        "altThreshold": 55,
        "resultTitle": "La pièce qui vous ressemble",
        "ctaLabel": "Je craque, voir la pièce →",
        "altsTitle": "Vous aimerez aussi",
        "launchLabel": "✦ Quelle céramique vous ressemble ?",
        "launchLabelShort": "✦ Le quiz"
      },
      "weights": {
        "type": 0.3,
        "repas": 0.24,
        "forme": 0.22,
        "taille": 0.16,
        "perso": 0.08
      },
      "questions": [
        {
          "id": "repas",
          "type": "single",
          "match": "has",
          "shortLabel": "Votre moment",
          "q": "Votre moment à table préféré, c'est…",
          "help": "Dites-nous ce qui vous fait vibrer.",
          "opts": [
            {
              "v": "apero",
              "ico": "🥂",
              "t": "L'apéro qui s'étire",
              "s": "On picore, on partage"
            },
            {
              "v": "four",
              "ico": "🔥",
              "t": "Le plat réconfortant du four",
              "s": "Gratins, plats mijotés"
            },
            {
              "v": "presentation",
              "ico": "🍷",
              "t": "La table dressée avec soin",
              "s": "Pour sublimer le repas"
            }
          ]
        },
        {
          "id": "type",
          "type": "single",
          "match": "category",
          "shortLabel": "Votre envie",
          "q": "De quoi avez-vous le plus envie ?",
          "help": "La pièce dont vous rêvez.",
          "opts": [
            {
              "v": "saladier",
              "ico": "🥗",
              "t": "Un grand contenant à partager",
              "s": "Saladiers"
            },
            {
              "v": "plat",
              "ico": "🍽️",
              "t": "Une belle pièce centrale",
              "s": "Plats à gratin, de service"
            },
            {
              "v": "assiette",
              "ico": "🍽",
              "t": "Des assiettes de caractère",
              "s": ""
            },
            {
              "v": "coupelle",
              "ico": "🥣",
              "t": "De petites pièces à picorer",
              "s": "Coupelles, bols"
            },
            {
              "v": "tasse",
              "ico": "☕",
              "t": "Une tasse rien qu'à soi",
              "s": ""
            },
            {
              "v": "autre",
              "ico": "✨",
              "t": "Surprenez-moi",
              "s": ""
            }
          ]
        },
        {
          "id": "taille",
          "type": "single",
          "match": "size",
          "shortLabel": "Votre tablée",
          "order": [
            "petit",
            "moyen",
            "grand",
            "tres-grand"
          ],
          "q": "Vous recevez plutôt…",
          "help": "Pour adapter la taille.",
          "opts": [
            {
              "v": "petit",
              "ico": "💞",
              "t": "En tête-à-tête",
              "s": ""
            },
            {
              "v": "moyen",
              "ico": "🏡",
              "t": "La petite famille",
              "s": ""
            },
            {
              "v": "grand",
              "ico": "🥳",
              "t": "Une tablée d'amis",
              "s": ""
            },
            {
              "v": "tres-grand",
              "ico": "🎉",
              "t": "La grande maisonnée",
              "s": ""
            }
          ]
        },
        {
          "id": "forme",
          "type": "single",
          "match": "category",
          "shortLabel": "L'allure",
          "q": "Quelle allure vous séduit ?",
          "help": "Une affaire de style.",
          "opts": [
            {
              "v": "rond",
              "ico": "<svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><circle cx='12' cy='12' r='8'/></svg>",
              "t": "Tout en rondeur",
              "s": ""
            },
            {
              "v": "carre",
              "ico": "<svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><rect x='5' y='5' width='14' height='14' rx='2'/></svg>",
              "t": "Graphique et carré",
              "s": ""
            },
            {
              "v": "rectangulaire",
              "ico": "<svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><rect x='3' y='7' width='18' height='10' rx='2'/></svg>",
              "t": "Tout en longueur",
              "s": ""
            },
            {
              "v": "autre",
              "ico": "<svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><circle cx='12' cy='7' r='3.2'/><circle cx='12' cy='17' r='3.2'/><circle cx='7' cy='12' r='3.2'/><circle cx='17' cy='12' r='3.2'/></svg>",
              "t": "Une forme qui sort du lot",
              "s": "Fleur, cœur, sapin…"
            }
          ]
        },
        {
          "id": "perso",
          "type": "single",
          "match": "personalize",
          "shortLabel": "Personnalisation",
          "q": "Envie d'une touche personnelle ?",
          "help": "Certaines pièces se personnalisent à la main.",
          "opts": [
            {
              "v": "oui",
              "ico": "✍️",
              "t": "Oui, avec un petit mot",
              "s": ""
            },
            {
              "v": "non",
              "ico": "🚫",
              "t": "Non, telle quelle",
              "s": ""
            }
          ]
        },
        {
          "id": "perso_texte",
          "type": "text",
          "match": "none",
          "showIf": {
            "perso": "oui"
          },
          "q": "Que souhaitez-vous y inscrire ?",
          "help": "20 caractères maximum.",
          "maxlength": 20,
          "placeholder": "Ex. : Mathilde, Joyeux Noël…"
        }
      ]
    },
    "cadeau": {
      "ui": {
        "maxAlts": 2,
        "altThreshold": 50,
        "resultTitle": "Le cadeau idéal",
        "ctaLabel": "Offrir cette pièce →",
        "altsTitle": "Autres idées cadeaux",
        "launchLabel": "✦ Trouver le cadeau parfait",
        "launchLabelShort": "✦ Idée cadeau"
      },
      "weights": {
        "type": 0.38,
        "budget": 0.27,
        "taille": 0.2,
        "perso": 0.15
      },
      "questions": [
        {
          "id": "pourqui",
          "type": "single",
          "match": "none",
          "shortLabel": "Destinataire",
          "q": "Pour qui cherchez-vous ?",
          "help": "On affine selon la personne.",
          "opts": [
            {
              "v": "cuisinier",
              "ico": "🍳",
              "t": "Un amoureux de cuisine",
              "s": ""
            },
            {
              "v": "couple",
              "ico": "💞",
              "t": "Un couple / une crémaillère",
              "s": ""
            },
            {
              "v": "hote",
              "ico": "🎀",
              "t": "Un proche qui adore recevoir",
              "s": ""
            },
            {
              "v": "soi",
              "ico": "🪞",
              "t": "Moi, je me fais plaisir",
              "s": ""
            }
          ]
        },
        {
          "id": "type",
          "type": "single",
          "match": "category",
          "shortLabel": "Type de pièce",
          "q": "Vous l'imaginez plutôt comme…",
          "help": "Le type de céramique à offrir.",
          "opts": [
            {
              "v": "saladier",
              "ico": "🥗",
              "t": "Un saladier à partager",
              "s": ""
            },
            {
              "v": "plat",
              "ico": "🍽️",
              "t": "Un beau plat",
              "s": "Gratin, présentation"
            },
            {
              "v": "assiette",
              "ico": "🍽",
              "t": "Des assiettes",
              "s": ""
            },
            {
              "v": "coupelle",
              "ico": "🥣",
              "t": "De jolies coupelles",
              "s": ""
            },
            {
              "v": "tasse",
              "ico": "☕",
              "t": "Une tasse / un mug",
              "s": ""
            },
            {
              "v": "autre",
              "ico": "✨",
              "t": "Autre chose",
              "s": ""
            }
          ]
        },
        {
          "id": "budget",
          "type": "single",
          "match": "price",
          "shortLabel": "Budget",
          "q": "Quel budget environ ?",
          "help": "On reste dans votre fourchette.",
          "opts": [
            {
              "v": "0-20",
              "ico": "💸",
              "t": "Petite attention",
              "s": "jusqu'à 20 €"
            },
            {
              "v": "20-40",
              "ico": "🎁",
              "t": "Un beau cadeau",
              "s": "20 à 40 €"
            },
            {
              "v": "40-9999",
              "ico": "💝",
              "t": "On se fait plaisir",
              "s": "40 € et +"
            }
          ]
        },
        {
          "id": "taille",
          "type": "single",
          "match": "size",
          "shortLabel": "Taille",
          "order": [
            "petit",
            "moyen",
            "grand",
            "tres-grand"
          ],
          "q": "Plutôt une petite ou une grande pièce ?",
          "help": "",
          "opts": [
            {
              "v": "petit",
              "ico": "🤏",
              "t": "Petite",
              "s": "< 10 cm"
            },
            {
              "v": "moyen",
              "ico": "🖐️",
              "t": "Moyenne",
              "s": "< 20 cm"
            },
            {
              "v": "grand",
              "ico": "🙌",
              "t": "Grande",
              "s": "< 30 cm"
            },
            {
              "v": "tres-grand",
              "ico": "📏",
              "t": "Très grande",
              "s": "> 30 cm"
            }
          ]
        },
        {
          "id": "perso",
          "type": "single",
          "match": "personalize",
          "shortLabel": "Personnalisation",
          "q": "On la personnalise ?",
          "help": "Un prénom, une date, un petit mot — l'idée cadeau parfaite.",
          "opts": [
            {
              "v": "oui",
              "ico": "✍️",
              "t": "Oui, avec un petit mot",
              "s": ""
            },
            {
              "v": "non",
              "ico": "🚫",
              "t": "Non, telle quelle",
              "s": ""
            }
          ]
        },
        {
          "id": "perso_texte",
          "type": "text",
          "match": "none",
          "showIf": {
            "perso": "oui"
          },
          "q": "Que souhaitez-vous y inscrire ?",
          "help": "20 caractères maximum.",
          "maxlength": 20,
          "placeholder": "Ex. : Mathilde, Joyeux Noël…"
        }
      ]
    }
  },
  "catalog": [
    {
      "id": "saladier-martele",
      "title": "Saladier martelé",
      "subtitle": "Saladier rond · fait main",
      "price": 38,
      "chips": [
        "Rond",
        "Saladier",
        "Présentation"
      ],
      "img": "https://images.unsplash.com/photo-1610701596007-11502861dcfa?w=800&q=70",
      "tags": {
        "forme": "rond",
        "type": "saladier",
        "taille": [
          "petit",
          "grand"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation",
          "apero"
        ],
        "perso": false
      }
    },
    {
      "id": "coupe-haute",
      "title": "Saucier",
      "subtitle": "Contenant haut · fait main",
      "price": 28,
      "chips": [
        "Rond",
        "Présentation"
      ],
      "img": "https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=800&q=70",
      "tags": {
        "forme": "rond",
        "type": "saladier",
        "taille": [
          "moyen"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation"
        ],
        "perso": false
      }
    },
    {
      "id": "plat-de-service-familiale",
      "title": "Plat de service XXL (familial)",
      "subtitle": "Très grand plat · Ø 39 cm",
      "price": 59,
      "chips": [
        "Rond",
        "Très grand",
        "Présentation"
      ],
      "img": "https://images.unsplash.com/photo-1603199506016-b9a594b593c0?w=800&q=70",
      "tags": {
        "forme": "rond",
        "type": "plat",
        "taille": [
          "tres-grand"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation",
          "four"
        ],
        "perso": false
      }
    },
    {
      "id": "coupelle-6-petales",
      "title": "Coupelles 6 Pétales",
      "subtitle": "Coupelle fleur · apéro",
      "price": 9,
      "chips": [
        "Fleur",
        "Petit",
        "Apéro"
      ],
      "img": "https://images.unsplash.com/photo-1578749556568-bc2c40e68b61?w=800&q=70",
      "tags": {
        "forme": "fleur",
        "type": "coupelle",
        "taille": [
          "petit"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "apero"
        ],
        "perso": false
      }
    },
    {
      "id": "poisson",
      "title": "Poisson",
      "subtitle": "Pièce forme poisson",
      "price": 18,
      "chips": [
        "Forme poisson",
        "Apéro",
        "Présentation"
      ],
      "img": "https://images.unsplash.com/photo-1589985270826-4b7bb135bc9d?w=800&q=70",
      "tags": {
        "forme": "poisson",
        "type": "coupelle",
        "taille": [
          "petit",
          "moyen"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "apero",
          "presentation"
        ],
        "perso": false
      }
    },
    {
      "id": "coupelle-crantee",
      "title": "Coupelle crantée",
      "subtitle": "Petite coupelle ronde",
      "price": 8,
      "chips": [
        "Rond",
        "Petit",
        "Apéro"
      ],
      "img": "https://images.unsplash.com/photo-1610701596061-2ecf227e85b2?w=800&q=70",
      "tags": {
        "forme": "rond",
        "type": "coupelle",
        "taille": [
          "petit"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "apero"
        ],
        "perso": false
      }
    },
    {
      "id": "sapin-en-ceramique",
      "title": "Sapin",
      "subtitle": "Coupelle forme sapin",
      "price": 12,
      "chips": [
        "Sapin",
        "Petit",
        "Apéro"
      ],
      "img": "https://images.unsplash.com/photo-1543258103-a62bdc069871?w=800&q=70",
      "tags": {
        "forme": "sapin",
        "type": "coupelle",
        "taille": [
          "petit"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "apero",
          "presentation"
        ],
        "perso": false
      }
    },
    {
      "id": "petit-coeur",
      "title": "Petit coeur",
      "subtitle": "Coupelle cœur",
      "price": 8,
      "chips": [
        "Cœur",
        "Petit",
        "Apéro"
      ],
      "img": "https://images.unsplash.com/photo-1612196808214-b40b3f3b4b3e?w=800&q=70",
      "tags": {
        "forme": "coeur",
        "type": "coupelle",
        "taille": [
          "petit"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "apero"
        ],
        "perso": false
      }
    },
    {
      "id": "saladier-pot",
      "title": "Saladier pot",
      "subtitle": "Saladier rond profond",
      "price": 34,
      "chips": [
        "Rond",
        "Saladier",
        "Table"
      ],
      "img": "https://images.unsplash.com/photo-1591814468924-caf88d1232e1?w=800&q=70",
      "tags": {
        "forme": "rond",
        "type": "saladier",
        "taille": [
          "moyen",
          "grand"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation"
        ],
        "perso": false
      }
    },
    {
      "id": "plat-a-gratin-avec-panier",
      "title": "Plat à gratin avec panier",
      "subtitle": "Plat rectangulaire + panier",
      "price": 45,
      "chips": [
        "Rectangulaire",
        "Four",
        "Grand"
      ],
      "img": "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=800&q=70",
      "tags": {
        "forme": "rectangulaire",
        "type": "plat",
        "taille": [
          "grand"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "four",
          "presentation"
        ],
        "perso": false
      }
    },
    {
      "id": "planche-carre",
      "title": "Plat carré extra plat",
      "subtitle": "Plat / planche carré",
      "price": 17,
      "chips": [
        "Carré",
        "Présentation",
        "Apéro"
      ],
      "img": "https://www.atelierdesgreffieres.com/cdn/shop/files/Plat_carre_presente.webp?v=1754130047",
      "tags": {
        "forme": "carre",
        "type": "plat",
        "taille": [
          "moyen",
          "grand"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation",
          "apero"
        ],
        "perso": false
      }
    },
    {
      "id": "plat-rectangulaire",
      "title": "Planche rectangulaire",
      "subtitle": "Planche de présentation",
      "price": 22,
      "chips": [
        "Rectangulaire",
        "Présentation",
        "Apéro"
      ],
      "img": "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=800&q=70",
      "tags": {
        "forme": "rectangulaire",
        "type": "plat",
        "taille": [
          "grand"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation",
          "apero"
        ],
        "perso": false
      }
    },
    {
      "id": "saladier-fleur-%F0%9F%8C%B8",
      "title": "Saladier fleur 🌸",
      "url": "https://www.atelierdesgreffieres.com/products/saladier-fleur-%F0%9F%8C%B8",
      "subtitle": "Saladier forme fleur",
      "price": 36,
      "chips": [
        "Fleur",
        "Saladier",
        "Table"
      ],
      "img": "https://images.unsplash.com/photo-1602170284347-3d9c4a78d3a5?w=800&q=70",
      "tags": {
        "forme": "fleur",
        "type": "saladier",
        "taille": [
          "moyen",
          "grand"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation"
        ],
        "perso": false
      }
    },
    {
      "id": "assiette-a-huitre",
      "title": "Assiette à huîtres",
      "subtitle": "Assiette de présentation",
      "price": 24,
      "chips": [
        "Rond",
        "Apéro",
        "Présentation"
      ],
      "img": "https://www.atelierdesgreffieres.com/cdn/shop/files/Assietteahuitreceramiqueatelier.webp?v=1759396427",
      "tags": {
        "forme": "rond",
        "type": "assiette",
        "taille": [
          "moyen"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation",
          "apero"
        ],
        "perso": false
      }
    },
    {
      "id": "plat-a-gratin-rectangulaire",
      "title": "Plat à gratin rectangulaire",
      "subtitle": "Plat à gratin · va au four",
      "price": 37,
      "chips": [
        "Rectangulaire",
        "Four",
        "Grand"
      ],
      "img": "https://www.atelierdesgreffieres.com/cdn/shop/files/photo_gros_plan_du_plat_a_gratin_avec_lasagnes_10x.webp?v=1759399512",
      "tags": {
        "forme": "rectangulaire",
        "type": "plat",
        "taille": [
          "grand",
          "tres-grand"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "four",
          "presentation"
        ],
        "perso": false
      }
    },
    {
      "id": "assiette-enfant-personnalisee",
      "title": "Assiette creuse personnalisée",
      "subtitle": "Assiette personnalisable",
      "price": 24,
      "chips": [
        "Rond",
        "Personnalisable",
        "Table"
      ],
      "img": "https://images.unsplash.com/photo-1525974160448-038dacadcc71?w=800&q=70",
      "tags": {
        "forme": "rond",
        "type": "assiette",
        "taille": [
          "moyen"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation"
        ],
        "perso": true
      }
    },
    {
      "id": "assiettes-coeur",
      "title": "Assiettes coeur",
      "subtitle": "Assiette forme cœur",
      "price": 12,
      "chips": [
        "Cœur",
        "Présentation",
        "Table"
      ],
      "img": "https://images.unsplash.com/photo-1591197172062-c718f82aba20?w=800&q=70",
      "tags": {
        "forme": "coeur",
        "type": "assiette",
        "taille": [
          "petit",
          "moyen"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation"
        ],
        "perso": false
      }
    },
    {
      "id": "plat-coeur-gratin",
      "title": "Plat Coeur à gratin ou présentation",
      "subtitle": "Plat cœur · va au four",
      "price": 32,
      "chips": [
        "Cœur",
        "Four",
        "Présentation"
      ],
      "img": "https://www.atelierdesgreffieres.com/cdn/shop/files/Plat_coeur_en_ceramique_de_l_atelier_des_greffieres_8159.webp?v=1753883879",
      "tags": {
        "forme": "coeur",
        "type": "plat",
        "taille": [
          "moyen",
          "grand"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "four",
          "presentation"
        ],
        "perso": false
      }
    },
    {
      "id": "coupelle-5-petales",
      "title": "Coupelle 5 pétales",
      "subtitle": "Coupelle fleur · apéro",
      "price": 7,
      "chips": [
        "Fleur",
        "Petit",
        "Apéro"
      ],
      "img": "https://images.unsplash.com/photo-1578500351865-d6c3706f46bc?w=800&q=70",
      "tags": {
        "forme": "fleur",
        "type": "coupelle",
        "taille": [
          "petit"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "apero"
        ],
        "perso": false
      }
    },
    {
      "id": "coupelle-ovale",
      "title": "Coupelle ovale",
      "subtitle": "Petite coupelle ovale",
      "price": 16,
      "chips": [
        "Forme originale",
        "Petit",
        "Apéro"
      ],
      "img": "https://images.unsplash.com/photo-1607344645866-009c320b63e0?w=800&q=70",
      "tags": {
        "forme": "ovale",
        "type": "coupelle",
        "taille": [
          "petit"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "apero"
        ],
        "perso": false
      }
    },
    {
      "id": "plat-rond-personnalise",
      "title": "Plat rond personnalisé",
      "subtitle": "Plat rond personnalisable",
      "price": 39,
      "chips": [
        "Rond",
        "Personnalisable",
        "Présentation"
      ],
      "img": "https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?w=800&q=70",
      "tags": {
        "forme": "rond",
        "type": "plat",
        "taille": [
          "moyen",
          "grand"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation"
        ],
        "perso": true
      }
    },
    {
      "id": "mugs-tasses-ceramique",
      "title": "Tasses & Mugs",
      "subtitle": "Tasse / mug en céramique",
      "price": 18,
      "chips": [
        "Rond",
        "Tasse",
        "Table"
      ],
      "img": "https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?w=800&q=70",
      "tags": {
        "forme": "rond",
        "type": "tasse",
        "taille": [
          "petit"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation"
        ],
        "perso": false
      }
    },
    {
      "id": "bol-vague",
      "title": "Bol vague",
      "subtitle": "Bol rond ondulé",
      "price": 14,
      "chips": [
        "Rond",
        "Bol",
        "Table"
      ],
      "img": "https://images.unsplash.com/photo-1530390185373-fb699cd2dcdf?w=800&q=70",
      "tags": {
        "forme": "rond",
        "type": "coupelle",
        "taille": [
          "petit",
          "moyen"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation",
          "apero"
        ],
        "perso": false
      }
    },
    {
      "id": "beurrier",
      "title": "Beurrier",
      "subtitle": "Accessoire de table",
      "price": 22,
      "chips": [
        "Accessoire",
        "Petit",
        "Table"
      ],
      "img": "https://images.unsplash.com/photo-1631729371254-42c2892f0e6e?w=800&q=70",
      "tags": {
        "forme": "rectangulaire",
        "type": "autre",
        "taille": [
          "petit"
        ],
        "couleur": [
          "bleu",
          "rose",
          "jaune",
          "beige",
          "vert",
          "sombre"
        ],
        "repas": [
          "presentation"
        ],
        "perso": false
      }
    }
  ]
};